import { Dispatch, SetStateAction, useState } from "react"
import Button from "../../../components/Button"
import Container from "../../../components/Container"
import UserTab from "../../../components/user/UserTab"
import ScheduleInterview from "../../../components/user/ScheduleInterview"
import AddTutorial from "../../../components/user/AddTutorial"


const Tutoring = () => {
    const [activity, setActivity] = useState(0)
    return(
        <Container>
            <UserTab />
            {activity === 0 && <TutoringHero setActivity = {setActivity}/>}
            {activity === 1 && <ScheduleInterview />}
            {activity === 2 && <AddTutorial />}
        </Container>
    )
}

export default Tutoring

const TutoringHero = ({ setActivity} : {
    setActivity: Dispatch<SetStateAction<number>>
}) => {
    return(
        <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[65vh] mt-5 p-5 ">
                <div>
                    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] my-4 px-5 flex justify-between items-center py-2 rounded-xl">
                        <p>Create an interview slot</p>
                        <Button onClick = {() => setActivity(1)}>Create</Button>
                    </div>
                    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] my-4 px-5 flex justify-between items-center py-2 rounded-xl">
                        <p>Upload a tutorial video</p>
                        <Button onClick = {() => setActivity(2)}>Upload</Button>
                    </div>
                    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] my-4 px-5 flex justify-between items-center py-2 rounded-xl">
                        <p>View uploaded tutorials</p>
                        <Button onClick = {() => setActivity(3)}>View</Button>
                    </div>
                </div>
            </div>
    )
}